export default "__VITE_ASSET__BYWuHiwy__"